
































































































































































import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { TableOptions, TableConfig, TableField } from '@/interfaces';
import CommonMixin from '@/mixins/CommonMixin';
import { Getter, Mutation } from 'vuex-class';
import { IDRec } from '@/interfaces';
import { Dictionary } from 'vue-router/types/router';
import DocPreviewDialog from '@/components/DocPreviewDialog.vue';

@Component({
  components: {
    DocPreviewDialog
  },
  metaInfo() {
    return {
      title: (this as any).overviewTitle
    };
  }
})
export default class OverviewLayout extends Mixins(CommonMixin) {
  @Prop(Object) public tableCfg!: TableConfig;
  @Prop(String) public extraColumnHeader!: string;
  @Prop({ type: Object, default: null }) public readonly fixedFilter!: object | null;

  // Initial values
  public deleteDialogValue = false;
  public recordId = 0;
  public filters: any = {};
  public advancedSearchVisible: boolean = false;
  public timeout: number = 0;
  public tableItems: object[] = [];
  public tableTotal: number = 0;
  public tableLoading = true;
  public selected: object[] = [];
  public tableFooterProps = {
    'items-per-page-options': [15, 25, 50, 100],
    'show-current-page': true,
    'show-first-last-page': true
  };

  // Table config values
  public priv = this.getPrivilege(this.tableCfg);
  public overviewTitle = this.getTableCfg(this.tableCfg, 'overviewTitle');
  public url = this.getTableCfg(this.tableCfg, 'url');
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');
  public multiSelect =
    this.getTableCfg(this.tableCfg, 'multiSelect') !== undefined
      ? this.getTableCfg(this.tableCfg, 'multiSelect')
      : false;
  public addRecord =
    this.getTableCfg(this.tableCfg, 'addRecord') !== undefined
      ? this.getTableCfg(this.tableCfg, 'addRecord')
      : true;
  public deletable = this.getTableCfg(this.tableCfg, 'deletable');
  public deleteTitle =
    this.getTableCfg(this.tableCfg, 'deleteTitle') !== undefined
      ? this.getTableCfg(this.tableCfg, 'deleteTitle')
      : '';
  public editable = this.getTableCfg(this.tableCfg, 'editable');
  public advancedSearchFields = this.getTableCfg(this.tableCfg, 'advancedSearchFields');
  public tableFields = this.getTableFields();
  public filterName = this.getTableCfg(this.tableCfg, 'filterName');
  public quickFilter = this.getTableCfg(this.tableCfg, 'quickFilter');
  public defaultPerPage = this.getTableCfg(this.tableCfg, 'defaultPerPage');
  public tableOptions: TableOptions = {
    page: 1,
    itemsPerPage: this.defaultPerPage ? this.defaultPerPage : 15,
    sortBy: this.getTableCfg(this.tableCfg, 'sortBy'),
    sortDesc: this.getTableCfg(this.tableCfg, 'sortDesc'),
    multiSort:
      this.getTableCfg(this.tableCfg, 'multiSort') !== undefined
        ? this.getTableCfg(this.tableCfg, 'multiSort')
        : false,
    mustSort: false
  };
  public totals = '';

  public get advancedSearch() {
    if (this.advancedSearchFields === undefined) {
      return false;
    } else {
      return this.advancedSearchFields.length > 0;
    }
  }

  // Computed
  public get readPrivilege() {
    return this.priv ? this.roleCheck(this.priv, 'read') : true;
  }

  public get writePrivilege() {
    return this.priv ? this.roleCheck(this.priv, 'write') : true;
  }

  public get managePrivilege() {
    return this.priv ? this.roleCheck(this.priv, 'manage') : true;
  }

  public get isReadOnlyOverview() {
    return (
      !this.writePrivilege ||
      this.getTableCfg(this.tableCfg, 'isReadOnlyOverview')
    );
  }

  public get tableHeaders(): object[] {
    const headers: object[] = [];
    for (const field of this.tableFields) {
      const header = {
        text: field.text,
        value: field.value,
        width: field.width || '',
        align: field.align || 'start',
        sortable: field.sortable !== undefined ? field.sortable : true
      };
      headers.push(header);
    }
    if (!this.isReadOnlyOverview && (this.editable || this.deletable)) {
      // Add action header
      headers.push({
        align: 'center',
        sortable: false,
        text: 'Acties',
        value: 'actions',
        width: '10%'
      });
    }
    if (this.$scopedSlots.ExtraColumn) {
      headers.push({
        align: 'center',
        sortable: false,
        text: this.extraColumnHeader,
        value: 'extra',
        width: '5%'
      });
    }
    return headers;
  }

  @Getter('getFilters')
  public getFilters!: (name: string) => object;

  @Mutation('setFilters')
  public setFilters;

  @Mutation('setFilterHash')
  public setFilterHash;


  @Getter('getTableOptions')
  public getTableOptions!: (name: string) => TableOptions;

  @Mutation('setTableOptions')
  public setTableOptions;

  @Getter('getAdvancedSearchVisible')
  public getAdvancedSearchVisible!: (name: string) => boolean;

  @Mutation('setAdvancedSearchVisible')
  public setAdvancedSearchVisible;

  // Filter Functions
  public toggleAdvancedSearchVisible() {
    this.advancedSearchVisible = !this.advancedSearchVisible;
    this.saveAdvancedSearchVisible();
  }

  public updateFilter(filter) {
    this.$emit('filterchanged', this.filters, filter);
    this.tableUpdateData(true);
  }

  public clearFilter(filter) {
    delete this.filters[filter];
    this.tableUpdateData(true);
  }

  public clearAllFilters() {
    this.filters = {};
    this.tableUpdateData(true);
  }

  public saveFilters() {
    this.setFilters({
      name: this.filterName,
      value: this.filters
    });
  }

  public saveTableOptions() {
    this.setTableOptions({
      name: this.filterName,
      value: this.tableOptions
    });
  }

  public saveAdvancedSearchVisible() {
    this.setAdvancedSearchVisible({
      name: this.filterName,
      value: this.advancedSearchVisible
    });
  }
  // Table Functions


  public getTableFields() {
    const allFields: TableField[] = this.getTableCfg(this.tableCfg, 'tableFields');
    const resultFields: TableField[] = [];
    for (const field of allFields) {
      if (field.access) {
        // console.log('Check Field Access', field.value, field.access, this.roleCheckIsA(field.access));
        if (!this.roleCheckIsA(field.access)) {
          continue;
        }
      }
      resultFields.push(field);

    }
    return resultFields;
  }

  public handleTotals(totals) {
    // console.log(totals);
    const totalFields = this.getTableCfg(this.tableCfg, 'totalFields');
    if (totalFields) {
      // console.log(totalFields);
      let result = '';
      const allFields: TableField[] = this.getTableCfg(this.tableCfg, 'tableFields');
      for (const totalfield of totalFields) {
        for (const field of allFields) {
          if (field.text === totalfield) {
            const v = totals[field.value];
            // console.log(totalfield, this.$options.filters[field.filter](v));
            if (result.length) {
              result += ', ';
            }
            if (field.filter && this.$options.filters) {
              result += totalfield + ' = ' + this.$options.filters[field.filter](v);
            } else {
              result += totalfield + ' = ' + v;
            }
          }
        }
      }
      if (result.length) {
            result = 'Totalen: ' + result;
          }
      this.totals = result;
      // console.log(result);
    }
    const totalGroupFields = this.getTableCfg(this.tableCfg, 'totalGroupFields');
    if (totalGroupFields) {
      let result = '';
      for (const [k, v] of Object.entries(totals)) {
        if (result.length) {
          result += ', ';
        }
        result += k + ' = ' + v;
      }
      if (result.length) {
            result = 'Totalen: ' + result;
          }
      this.totals = result;
    }

  }

  public getIcon(ext) {
    switch (ext) {
      case '.xlsx':
        return 'mdi-file-excel-outline';
      case '.pdf':
        return 'mdi-file-pdf-outline';
      case '.pdfs':
        return 'mdi-file-pdf';
      default:
        return 'mdi-download';
    }
  }

  public generateSlotName(field): string {
    const header = field.value;
    // console.log('generateSlotName', field, `item.${field.value}`);
    return `item.${header}`;
  }

  // Support nested values
  public getItemValue(item, field) {
    const value = field.key ? field.key : field.value;
    const subelements = value.split('.');
    let itemValue = item;
    for (const subelement of subelements) {
      itemValue = itemValue[subelement];
    }
    return itemValue;
  }

  public getLink(link, item) {
    const parsedLink = link;
    const params: string[] = link.match(/{([^}]*)}/g);
    for (const param of params) {
      // Remove brackets
      const paramValue = param.substring(1, param.length - 1);
      const regExp = new RegExp(param);
      link = link.replace(regExp, item[paramValue]);
    }
    return link;
  }

  public goToNewDetail() {
    this.$router.push(this.url + '/new');
  }

  public downloadItem(endpoint, id) {
    this.api.downloadFile(this.$store, this.apiUrl + id + '/' + endpoint);
  }

  public previewItem(endpoint, id) {
    const ref: any = this.$refs.docpreview;
    ref.open(this.apiUrl + id + '/' + endpoint);
  }

  public previewUrl(url) {
    const ref: any = this.$refs.docpreview;
    ref.openurl(url);
  }


  public openItem(endpoint, id) {
    this.api.openFile(this.$store, this.apiUrl + id + '/' + endpoint);
  }

  public editItem(id) {
    const path = this.url + '/' + String(id) + '?mode=edit';
    this.$router.push(path);
  }

  public deleteItem(id) {
    this.deleteDialogValue = true;
    this.recordId = id;
  }

  public async deleteRecord(id) {
    await this.api.deleteRecord(this.$store, this.apiUrl + id);
    this.tableUpdateData(false);
  }

  public countSelections() {
    return this.selected.length;
  }

  public getSelectedIds() {
    return this.selected.map(element => {
      return (element as IDRec).id;
    });
  }

  public filteredOverview() {
    return Object.keys(this.filters).length > 0;
  }

  public setFilterValues(filterValues: object) {
    // console.log('setFilterValues', filterValues);
    for (const key of Object.keys(filterValues)) {
      this.$set(this.filters, key, filterValues[key]);
    }
    this.tableUpdateData(true);
  }

  public getFilterValues(filterValues: object) {
    Object.assign(filterValues, this.filters);
    if (this.fixedFilter) {
      Object.assign(filterValues, this.fixedFilter);
    }
    // Remove invalid filters
    for (const filter in filterValues) {
      if (
        filterValues[filter] === '' ||
        filterValues[filter] === null ||
        filterValues[filter] === undefined
      ) {
        delete filterValues[filter];
      }
    }
  }

  public getSortString() {
    let sort: string = '';
    const sortBy: string[] = this.tableOptions.sortBy;
    const sortDesc: boolean[] = this.tableOptions.sortDesc;
    for (let i = 0; i < sortBy.length; i++) {
      if (!sort) {
        // First sort parameter
        sort = sortBy[i] + (sortDesc[i] ? '|D' : '');
      } else {
        sort += ',' + sortBy[i] + (sortDesc[i] ? '|D' : '');
      }
    }
    return sort;
  }
  public setSortString(input: string) {
    const sortBy: string[] = [];
    const sortDesc: boolean[] = [];
    const sort = input.split(',');
    for (const s of sort) {
      if (s.includes('|D')) {
        sortBy.push(s.replace('|D', ''));
        sortDesc.push(true);
      } else {
        sortBy.push(s);
        sortDesc.push(false);
      }
    }
    this.tableOptions.sortBy = sortBy;
    this.tableOptions.sortDesc = sortDesc;
  }

  public async tableUpdateData(resetPage) {
    if (resetPage) {
      this.tableOptions.page = 1;
    }
    this.tableLoading = true;
    this.saveTableOptions();
    const params: Dictionary<number | string> = {
      page: this.tableOptions.page,
      per_page: this.tableOptions.itemsPerPage
    };
    params.sort = this.getSortString();
    this.saveFilters();
    this.getFilterValues(params);
    if (
      this.queryString.stringify(this.$route.query) !==
      this.queryString.stringify(params)
    ) {
      this.$router.replace({ query: params as Dictionary<string> });
    }
    const response = await this.api.getTableData(
      this.$store,
      this.apiUrl,
      params
    );
    if (response) {
      this.tableItems = response.data.data;
      this.tableTotal = response.data.pagination.total;
      this.setFilterHash({
        name: this.filterName,
        value: response.data.pagination.filter_hash
      });
      this.handleTotals(response.data.totals);
    }
    this.tableLoading = false;
    this.$emit('tableloaded', this);
  }
  public handleItemSelected(event) {
    this.$emit('item-selected', this, event);
  }
  public handleToggleSelectAll(event) {
    this.$emit('toggle-select-all', this, event);
  }
  public handleChangeMultiSelect(event) {
    this.$emit('change-multi-select', this, event);
  }



  // Update table 2 seconds after user is done typing
  public onQuickFilterChanged(value: string, oldValue: string) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.tableUpdateData(true);
    }, 2000);
  }

  public evaluateParams(staticParams, dynamicParams) {
    let params = {};
    if (staticParams) {
      params = staticParams;
    }
    if (dynamicParams) {
      const evaluatedParams = this.evaluateDynamicParams(dynamicParams);
      // Merge static params with evaluated dynamic params
      params = JSON.parse(JSON.stringify({ ...params, ...evaluatedParams }));
    }
    return params;
  }

  public evaluateDynamicParams(params) {
    const evaluatedParams = {};
    for (const key of Object.keys(params)) {
      const value = params[key];
      // tslint:disable-next-line: no-eval
      evaluatedParams[key] = eval(value);
    }
    return evaluatedParams;
  }

  public initRouteQuery() {
    const savedTableOptions: TableOptions = this.getTableOptions(
      this.filterName
    );
    if (savedTableOptions) {
      this.tableOptions = savedTableOptions;
    }
    const queries = this.$route.query;
    if (queries) {
      // Get initial queries
      const filters = this.getFilters(this.filterName) || {};
      for (const query in queries) {
        if (query.includes('id')) {
          // Make sure option lists show selected value
          filters[query] = Number(queries[query]);
        } else if (query.includes('state')) {
          // Make sure option lists show selected value
          filters[query] = Number(queries[query]);
        } else if (query === 'advanced') {
          this.setAdvancedSearchVisible({
            name: this.filterName,
            value: true
          });
        } else if (query === 'page') {
          this.tableOptions.page = Number(queries[query]);
        } else if (query === 'per_page') {
          this.tableOptions.itemsPerPage = Number(queries[query]);
        } else if (query === 'sort') {
          this.setSortString(queries[query] as string);
        } else {
          filters[query] = queries[query];
        }
      }
      this.setFilters({
        name: this.filterName,
        value: filters
      });
    }
  }

  public customEditable(item) {
    if (this.tableCfg.customEditable) {
      return this.tableCfg.customEditable(this, item);
    } else {
      return true;
    }
  }

  public customDeletable(item) {
    if (this.tableCfg.customDeletable) {
      return this.tableCfg.customDeletable(this, item);
    } else {
      return true;
    }
  }

  // Lifecycle Functions
  public created() {
    if (!this.readPrivilege) {
      this.$router.push('/noaccess');
    }
    this.$watch(
      'tableOptions',
      function(newValue, oldValue) {
          // console.log('OverviewLayout.$watch tableOptions', oldValue, '->',  newValue);
          if (this.readPrivilege) {
            this.tableUpdateData(false);
          }
        }
    );
  }

  // Get filters and table options from store when view is created
  public mounted() {
    this.initRouteQuery();
    const filters = this.getFilters(this.filterName);
    if (filters) {
      this.filters = filters;
    }
    const advancedSearchVisible: boolean = this.getAdvancedSearchVisible(
      this.filterName
    );
    if (advancedSearchVisible) {
      this.advancedSearchVisible = advancedSearchVisible;
    }
  }

  // Save filters and table options before leaving the view
  public beforeDestroy() {
    this.saveFilters();
    this.saveTableOptions();
  }
}
